<template>
  <div
    class="quest-pause-screensaver"
    @click="handleClick">
    <div
      class="quest-pause-screensaver__bouncer"
      ref="bouncer"
      :style="bouncerStyle">
      <img
        v-if="imageUrl"
        ref="image"
        :src="imageUrl"
        :alt="questName"
        class="quest-pause-screensaver__image"
        @load="onImageLoad" />
      <h1 class="quest-pause-screensaver__title">{{ questName }}</h1>
      <p
        class="quest-pause-screensaver__hint">
        <PlayIcon class="quest-pause-screensaver__hint-icon" />
        Click anywhere to continue
      </p>
    </div>
  </div>
</template>

<script>
import PlayIcon from "@images/font_awesome/play-circle-light.svg";

export default {
  name: "QuestPauseScreensaver",
  components: {
    PlayIcon
  },
  props: {
    imageUrl: {
      type: String,
      default: ""
    },
    questName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      bouncerWidth: 320,
      bouncerHeight: 260,
      bouncerX: 100,
      bouncerY: 100,
      velocityX: 0.9,
      velocityY: 0.7,
      bouncerAnimationId: null
    }
  },
  computed: {
    bouncerStyle() {
      return {
        transform: `translate(${this.bouncerX}px, ${this.bouncerY}px)`
      };
    }
  },
  methods: {
    handleClick() {
      this.$emit("continue");
    },
    startBouncerAnimation() {
      const animate = () => {
        const maxX = window.innerWidth - this.bouncerWidth;
        const maxY = window.innerHeight - this.bouncerHeight;

        this.bouncerX += this.velocityX;
        this.bouncerY += this.velocityY;

        if (this.bouncerX <= 0 || this.bouncerX >= maxX) {
          this.velocityX *= -1;
          this.bouncerX = Math.max(0, Math.min(this.bouncerX, maxX));
        }

        if (this.bouncerY <= 0 || this.bouncerY >= maxY) {
          this.velocityY *= -1;
          this.bouncerY = Math.max(0, Math.min(this.bouncerY, maxY));
        }

        this.bouncerAnimationId = requestAnimationFrame(animate);
      };

      this.bouncerAnimationId = requestAnimationFrame(animate);
    },
    stopBouncerAnimation() {
      if (this.bouncerAnimationId) {
        cancelAnimationFrame(this.bouncerAnimationId);
        this.bouncerAnimationId = null;
      }
    },
    onImageLoad() {
      this.measureAndStartAnimation();
    },
    measureAndStartAnimation() {
      this.bouncerWidth = this.$refs.bouncer.offsetWidth;
      this.bouncerHeight = this.$refs.bouncer.offsetHeight;
      this.startBouncerAnimation();
    }
  },
  mounted() {
    if (!this.imageUrl) {
      this.$nextTick(() => {
        this.measureAndStartAnimation();
      });
    }
  },
  beforeDestroy() {
    this.stopBouncerAnimation();
  }
}
</script>

<style lang="scss">
.quest-pause-screensaver {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  background-color: $grey-1;

  cursor: pointer;
  overflow: hidden;

  &__bouncer {
    width: $px320;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;

    will-change: transform;
  }

  &__image {
    width: 100%;
    height: auto;
    margin-bottom: $px16;

    border-radius: $px12;
    border: $px2 solid $blue-5;

    object-fit: cover;
    filter: drop-shadow(0 0 $px24 rgba($blue-5, 0.6));
  }

  &__title {
    margin: 0 0 $px12;

    color: $white;
    @include h3;
    text-align: center;
    text-shadow: 0 0 $px16 rgba($blue-5, 0.8);
  }

  &__hint {
    display: flex;
    align-items: center;
    gap: $px4;
    margin: 0;

    color: $grey-6;
    font-size: $px12;
    text-align: center;

    opacity: 0.7;
  }

  &__hint-icon {
    width: $px20;
    height: $px20;

    color: $grey-6;
  }
}
</style>
